import { TFunction } from "i18next";

import { LABEL } from "./types";

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
export default function getDislikeFeedbackOptions(t: TFunction) {
  return [
    {
      label: t("chat:modal.rateVoiceQuality.dislikeFeedback.notNatural"),
      subLabel: LABEL.NOT_NATURAL,
    },
    {
      label: t("chat:modal.rateVoiceQuality.dislikeFeedback.pronunciationUnclear"),
      subLabel: LABEL.PRONUNCIATION_UNCLEAR,
    },
    {
      label: t("chat:modal.rateVoiceQuality.dislikeFeedback.toneMismatch"),
      subLabel: LABEL.TONE_MISMATCH,
    },
    {
      label: t("chat:modal.rateVoiceQuality.dislikeFeedback.tooFast"),
      subLabel: LABEL.TOO_FAST,
    },
    {
      label: t("chat:modal.rateVoiceQuality.dislikeFeedback.tooSlow"),
      subLabel: LABEL.TOO_SLOW,
    },
  ];
}
